import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { BaseItemComponent } from '../base-item/base-item.component';
import { CartItem } from '../../../models/cart-item.model';

@Component({
  selector: 'usb-transport-item',
  templateUrl: './transport-item.component.html',
  styleUrls: ['./transport-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransportItemComponent extends BaseItemComponent {
  @Input() item: any;
  @Input() clientsSettingAppBooking: any;
  @Output() removeTransfer = new EventEmitter<any>();

  getOriginLabel(): string {
    if (this.item?.origin?.type === 'airport') {
      return this.item.origin.name || '';
    }
    return this.item?.origin?.city_name || '';
  }

  getDestinationLabel(): string {
    return this.item?.destination?.city_name || '';
  }

  getTranportStatusClass(statusId: number): string {
    const statusMap: { [key: number]: string } = {
      1: 'product-status-saved',
      2: 'product-status-reserved',
      3: 'product-status-locked',
      4: 'product-status-denied',
      5: 'product-status-cancelled',
      6: 'product-status-paid-agency',
      7: 'product-status-paid-provider',
      8: 'product-status-completed'
    };
    return statusMap[statusId] || '';
  }

  getTransferDisplayPrice(transfer: any): number {
    if (transfer?.statusId === 5) {
      return 0;
    }
    if (this.item?.isPaidAgency || this.item?.isPaidProvider) {
      return transfer?.convertedAmounts?.netPriceAgent || transfer?.netPrice || 0;
    }
    return this.currency.transform(
      transfer?.netPriceAgent,
      transfer?.currency,
      this.currencyAgency?.code,
      this.currencies
    ) || 0;
  }

  onRemoveItem(item: any): void {
    this.removeTransfer.emit(item);
  }
}
